import { render } from "./TemplateEditor.vue?vue&type=template&id=189f73d9"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__